import React from 'react';
import { FaUserFriends, FaRegLightbulb, FaLandmark } from 'react-icons/fa';
import './ProvenanceAdvantage.css';

const ProvenanceAdvantage = () => {
  const features = [
    {
      id: 1,
      icon: <FaUserFriends size={32} />, 
      title: "Our people",
      desc: "Our dedicated team of agronomists and supply chain experts are deeply embedded in local farming communities. You benefit not just from raw data, but from deep operational experience that bridges the gap between the farm gate and global markets."
    },
    {
      id: 2,
      icon: <FaRegLightbulb size={32} />,
      title: "Methodologies",
      desc: "Our market insights are built on transparent and rigorous assessment standards tailored for the volatility of agriculture. We combine real-time field surveys with advanced analytics to ensure our market intelligence reflects the true reality of the commodity supply chain."
    },
    {
      id: 3,
      icon: <FaLandmark size={32} />,
      title: "Heritage",
      desc: "Rooted in the principles of integrity and traceability, Provenance carries forward a legacy of trust. We are dedicated to supporting and streamlining the journey from seed to shelf, fostering a transparent ecosystem that supports sustainable global trade."
    }
];

  return (
    <section id="provenance-advantage" className="advantage-section container">
      <div className="advantage-header">
        <h2>The Provenance advantage</h2>
      </div>

      <div className="advantage-grid">
        {features.map((item) => (
          <div key={item.id} className="advantage-card">
            {/* The double circle effect will be handled in CSS */}
            <div className="icon-wrapper">
                <div className="icon-circle">
                    {item.icon}
                </div>
            </div>
            <h3>{item.title}</h3>
            <p>{item.desc}</p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default ProvenanceAdvantage;